import { useDispatch, useSelector } from 'react-redux';
import { selectCartIsGroupOrder } from 'bento-ordering/cart/selectors';
import { handleGroupOrderWebSocketError } from 'bento-ordering/group_ordering/actions/index';

const useWebSocketErrorHandler = () => {
  const dispatch = useDispatch();
  const isGroupOrder = useSelector(selectCartIsGroupOrder);

  const handleWebSocketError = () => {
    if (isGroupOrder) {
      dispatch(handleGroupOrderWebSocketError());
    }
  };

  return handleWebSocketError;
};

export default useWebSocketErrorHandler;
